<template>
  <div v-if="show">
    <button
      @click="isOpen = !isOpen"
      :class="['expandable-select__toggle', {
        'expandable-select__toggle--isOpen': isOpen,
        'expandable-select__toggle--value-set': modelValue
      }]"
      type="button"
    >
      <span :class="[{'expandable-select__text': modelValue}]">{{heading}}</span>
      <img :class="['expandable-select__icon', {'expandable-select__icon--isOpen': isOpen }]" :src="chevron" />
    </button>
    <div v-if="isOpen" class="expandable-select__content">
      <div :class="['expandable-select__wrapper', {'expandable-select__wrapper--rows': layout === 'rows'}]">
        <template v-for="option in options" :key="option.value">
          <label :class="['expandable-select__label', {'expandable-select__input--isSelected': modelValue === option.value}]">
            <input
              @input="$emit('update:modelValue', $event.target.value)"
              :checked="modelValue === option.value"
              :name="groupName"
              :value="option.value"
              class="expandable-select__input"
              type="radio"
            >
            <span class="expandable-select__circle">
              <span :class="[{'expandable-select__circle-inner': modelValue === option.value }]"></span>
            </span>
            {{ option.label || option.value}}
          </label>
        </template>
      </div>
      <div class="expandable-select__buttons">
        <button
          @click="$emit('update:modelValue', '')"
          class="btn btn--ghost"
          type="button"
        >
          Clear
        </button>
        <button
          @click="isOpen = false"
          class="btn btn--tertiary expandable-select__buttons-tertiary"
          type="button"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
const { cdn } = config

export default {
  name: 'ExpandableSelect',
  props: {
    modelValue: {
      type: String
    },
    options: {
      type: Array
    },
    show: {
      type: Boolean,
      default: true
    },
    layout: {
      type: String,
      default: 'grid',
      validator (value, props) {
        return ['grid', 'rows'].includes(value)
      }
    },
    title: {
      type: String
    }
  },
  data: () => {
    return {
      chevron: `${cdn}chevron-icon.svg`,
      groupName: 'radio-group-' + Date.now(),
      isOpen: false
    }
  },
  computed: {
    heading () {
      const selectedOption = this.options.find(option => option.value === this.modelValue)
      return selectedOption?.label ?? selectedOption?.value ?? this.title
    }
  }
}
</script>
